

export const COACHES = [
  {
    slug: 'fabrizio-pavez',
    name: 'Fabrizio Pavez',
    image: 'https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/nga0jdg6_logo-fab-1.jpg',
    titleKey: 'academyDirector',
    experienceKey: 'cpo',
    specialtyKey: 'academyLeadership'
  },
  {
    slug: 'antoine-laurent',
    name: 'Antoine Laurent',
    image: 'https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/ccy5apxb_logo-antoine-1.jpg',
    titleKey: 'coach',
    experienceKey: 'cngo',
    specialtyKey: 'nextGenTraining'
  },
  {
    slug: 'alejandro-nieuwenhuis',
    name: 'Alejandro Nieuwenhuis',
    image: 'https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/cf80wje7_logo-ale-2.jpg',
    titleKey: 'coach',
    experienceKey: 'cngo',
    specialtyKey: 'professionalTraining'
  }
];
